import React, { useState } from "react";
import { Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import TestOption from "../compnents/TestOption";
import TestTitle from "../compnents/TestTitle";
import ImagePicker from "../compnents/ImagePicker";
import FileUploader from "@jumbo/Dashboards/Media/FileUploader";

const useStyles = makeStyles((theme) => ({
  answerSelectText: {
    color: theme.palette.primary.main,
    fontWeight: "bold",
  },
}));

const GuessWordQuestionElement = ({
  questoinTitle,
  setQuestoinTitle,
  cover,
  setCover,
  score,
  setScore,
  wordAnswer,
  setWordAnswer,
  wordTryCount,
  setWordTryCount,
}) => {
  const classes = useStyles();
  const [openFileUploader, setOpenFileUploader] = useState(false);

  return (
    <React.Fragment>
      <TestTitle
        value={questoinTitle}
        handeChange={(value) => setQuestoinTitle(value)}
      />
      <Grid item xs={12}>
        <Typography className={classes.answerSelctText}>
          انتخاب تصویر سوال
        </Typography>
        <ImagePicker
          cover={cover}
          handlePick={() => setOpenFileUploader(true)}
          handleRevome={() => setCover("")}
          previewStyles={{ marginInline: "auto", marginBlock: "20px" }}
          placeHolderStyles={{ marginInline: "auto", marginBlock: "20px" }}
        />
      </Grid>
      <TestOption
        text={""}
        title={"گزینه صحیح"}
        type={"text"}
        value={wordAnswer}
        handleChange={(value) => setWordAnswer(value)}
      />
      <TestOption
        text={""}
        title={"تعداد تلاش"}
        type={"number"}
        value={wordTryCount}
        handleChange={(value) => setWordTryCount(+value)}
      />
      <TestOption
        text={""}
        title={"پله"}
        type={"number"}
        value={score}
        handleChange={(value) => setScore(+value)}
      />
      <FileUploader
        selectMode
        open={openFileUploader}
        handleClose={() => setOpenFileUploader(false)}
        handleSelect={(selected) => setCover(selected)}
        selectedItem={cover}
        imageSelector={true}
      />
    </React.Fragment>
  );
};
export default GuessWordQuestionElement;
